export const fetchDashboards = resp => {
  return {
    type: "FETCH_DASHBOARDS",
    payload: resp
  };
};

export const fetchInfiniteDashboards = resp => {
  return {
    type: "FETCH_INFINITE_DASHBOARDS",
    payload: resp
  };
};

export const setDashboardSelectedOrg = org => {
  return {
    type: "SET_DASHBOARD_SELECTED_ORG",
    org
  };
};

export const resetDashboardSelectedOrg = () => {
  return {
    type: "RESET_DASHBOARD_SELECTED_ORG"
  };
};

export const saveDashboardStateToCache = () => ({
  type: "SAVE_DASHBOARD_STATE_TO_CACHE"
});

export const restoreDashboardStateFromCache = () => ({
  type: "RESTORE_DASHBOARD_STATE_FROM_CACHE"
});



// WEBPACK FOOTER //
// ./src/actions/actions/dashboard.js